import InformationCircleIcon from "@heroicons/react/24/outline/InformationCircleIcon";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";

import cx from "@hsl/core/utils/cx";

import CircularButton from "../../CircularButton";
import Tooltip from "../../Tooltip/Tooltip";
import { type Props } from "./CheckboxListContainer";

export const CheckboxListLabel = ({
    isOpen,
    title,
    tooltip,
    toggleOpen,
}: Pick<Props, "isOpen" | "title" | "tooltip"> & { toggleOpen(): void }) => {
    return (
        <div className="flex w-full items-center justify-between">
            <span
                className="flex flex-1 cursor-pointer gap-1 font-medium"
                onClick={(e) => e.stopPropagation()}
            >
                {title}
                {tooltip && tooltip.content && (
                    <Tooltip {...tooltip}>
                        <InformationCircleIcon className="h-3.5 w-3.5 -translate-y-0.5" />
                    </Tooltip>
                )}
            </span>
            <CircularButton
                icon={
                    <XMarkIcon
                        width={16}
                        className={cx("transition-all hover:opacity-75", {
                            "rotate-45": !isOpen,
                        })}
                    />
                }
                onClick={toggleOpen}
            />
        </div>
    );
};
